import {
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER,
  SIGNIN_USER_ERROR,
  SIGNOUT_USER_SUCCESS,
  SIGNIN_USER,
  VALIDATE_REGISTRATION_TOKEN,
  VALIDATE_REGISTRATION_TOKEN_SUCCESS,
  VALIDATE_REGISTRATION_TOKEN_ERROR,
  ACCEPT_INVITATION,
  ACCEPT_INVITATION_SUCCESS,
  UPDATE_LAST_ACTIVE_SUCCESS,
  VALIDATE_PASSWORD_RESET_TOKEN,
  VALIDATE_PASSWORD_RESET_TOKEN_SUCCESS,
  VALIDATE_PASSWORD_RESET_TOKEN_ERROR,
  UPDATE_AUTH_USER_DATA_SUCCESS,
} from '../constants/ActionTypes'

import AuthState from 'model/state/AuthState';
import { AuthPayload } from 'actions/Auth';
import { CustomAction } from 'model/state';
import { createCookies } from 'helper/cookies';

const browserCache = createCookies();

const initialState: AuthState = {
  userId: browserCache.get('userId'),
  token: browserCache.get('token'),
  user: undefined,
  lastActive: browserCache.get('lastActive'),
  isSubmitting: false,
  isFetching: true,
  invitationData: {
    token: '',
    metadata: {
      email: '',
      locale: '',
      tokenId: ''
    }
  },
  verifiedOK: false,
}

function authReducer(state: AuthState | undefined = initialState, action: CustomAction<AuthPayload>) {
  switch (action.type) {
    case SIGNIN_USER:
      return { ...state, isSubmitting: true };

    case SIGNIN_USER_SUCCESS:
      return {
        ...state,
        user: action.payload?.user as any,
        userId: action.payload?.user?.id as any,
        token: action.payload?.token,
        isSubmitting: false
      };

    case SIGNIN_USER_ERROR:
      return { ...state, isSubmitting: false};

    case UPDATE_AUTH_USER_DATA_SUCCESS:
      return { ...state, user: action.payload?.user };

    case SIGNOUT_USER:
    case SIGNOUT_USER_SUCCESS:
      return { 
        ...state, 
        userId: null,
        token: null,
        user: null
      }

    case VALIDATE_REGISTRATION_TOKEN:
      return { ...state, isFetching: true };

    case VALIDATE_REGISTRATION_TOKEN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        invitationData: {
          ...state.invitationData,
          token: action.payload?.invitationData?.token || initialState.invitationData.token,
          metadata: action.payload?.invitationData?.metadata || initialState.invitationData.metadata
        }
      };

    case VALIDATE_REGISTRATION_TOKEN_ERROR:
      return { ...state, isFetching: false };

    case ACCEPT_INVITATION:
      return { ...state, verifiedOK: false };

    case ACCEPT_INVITATION_SUCCESS:
      return { ...state, verifiedOK: true };

    case UPDATE_LAST_ACTIVE_SUCCESS: {
      return { ...state, lastActive: action.payload?.lastActive };
    }

    case VALIDATE_PASSWORD_RESET_TOKEN: {
      return { ...state, isFetching: true };
    }

    case VALIDATE_PASSWORD_RESET_TOKEN_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        resetPasswordToken: action.payload?.token || undefined,
      };
    }

    case VALIDATE_PASSWORD_RESET_TOKEN_ERROR: {
      return { ...state, isFetching: false };
    }

    default:
      return state
  }
}

export default authReducer